/**
 * @generated SignedSource<<f6f428f4e6932ca716d7c194db82628e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CloseAccountFeedback = "COMPETITOR" | "NEW_ACCOUNT" | "NO_SURVEYS" | "OTHER" | "PRIVACY";
export type CloseAccountInput = {
  feedback?: string | null;
  reason: CloseAccountFeedback;
  retainData: boolean;
};
export type useCloseAccountMutation$variables = {
  input: CloseAccountInput;
};
export type useCloseAccountMutation$data = {
  readonly closeAccount: string | null;
};
export type useCloseAccountMutation = {
  response: useCloseAccountMutation$data;
  variables: useCloseAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "closeAccount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCloseAccountMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCloseAccountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aea0f8b44f813643da29e0e7b3a595b3",
    "id": null,
    "metadata": {},
    "name": "useCloseAccountMutation",
    "operationKind": "mutation",
    "text": "mutation useCloseAccountMutation(\n  $input: CloseAccountInput!\n) {\n  closeAccount(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "e22dccac0dc9736169d50b781c844e92";

export default node;
